import React from 'react';

import { Button, Card, Flex, Heading, Icon, Image, Link, Progress, Tag, Text } from '@chakra-ui/react';
import ProgressBar from './utils/ProgressBar';
import './styles/TestimonialCard.css';
import { FaArrowUpLong, FaPlus } from 'react-icons/fa6';

function TestimonialCard(props: any) {

    let details = props.details;

    return (
        <div>
            {/* Desktop only view */}
            <Card.Root className='testimonial_card__parent' backgroundColor='#f0f0f0' border='none' borderRadius='20px' maxW="sm" minW='xs' overflow="hidden">
                <Card.Body gap="4">
                    <Flex direction='column' gap='1'>
                        <Card.Title color='black'>{details.role} @{details.company}</Card.Title>
                        <Flex>
                            <Tag.Root backgroundColor='green.200' borderRadius='10px' color='green' fontWeight='bold' variant="solid" padding='9px'>
                                <Tag.Label fontSize='sm' fontWeight='bold'>+ ${details.total_increase} total increase</Tag.Label>
                            </Tag.Root>
                        </Flex>
                    </Flex>
                    <Card.Description>
                        <Flex direction='column' gap='4'>
                            <Flex direction='column' gap='1'>
                                <Flex direction='column' gap='0'>
                                    <Text color='gray' fontSize='2xs'>
                                        BASE SALARY
                                    </Text>
                                    <Heading color='black' fontWeight='bold' size='sm'>
                                        ${details.initial.base} &rarr; ${details.final.base}
                                    </Heading>
                                </Flex>
                                <ProgressBar changed={details.initial.base != details.final.base}/>
                            </Flex>
                            <Flex direction='column' gap='2'>
                                <Flex direction='column' gap='0'>
                                    <Text color='gray' fontSize='2xs'>
                                        RSU GRANT / 4 YEARS
                                    </Text>
                                    <Heading color='black' fontWeight='bold' size='sm'>
                                        ${details.initial.rsus} &rarr; ${details.final.rsus}
                                    </Heading>
                                </Flex>
                                <ProgressBar changed={details.initial.rsus != details.final.rsus}/>
                            </Flex>
                            <Flex direction='column' gap='2'>
                                <Flex direction='column' gap='0'>
                                    <Text color='gray' fontSize='2xs'>
                                        ANNUAL BONUS
                                    </Text>
                                    <Heading color='black' fontWeight='bold' size='sm'>
                                        ${details.initial.annual_bonus} &rarr; ${details.final.annual_bonus}
                                    </Heading>
                                </Flex>
                                <ProgressBar changed={details.initial.annual_bonus != details.final.annual_bonus}/>
                            </Flex>
                            <Flex direction='column' gap='2'>
                                <Flex direction='column' gap='0'>
                                    <Text color='gray' fontSize='2xs'>
                                        SIGN ON BONUS
                                    </Text>
                                    <Heading color='black' fontWeight='bold' size='sm'>
                                        ${details.initial.sign_on_bonus} &rarr; ${details.final.sign_on_bonus}
                                    </Heading>
                                </Flex>
                                <ProgressBar changed={details.initial.sign_on_bonus != details.final.sign_on_bonus}/>
                            </Flex>
                        </Flex>
                    </Card.Description>
                </Card.Body>
            </Card.Root>

            {/* Mobile only view */}
            <Card.Root className='testimonial_card__mobile_parent' backgroundColor='#f0f0f0' border='none' borderRadius='20px' maxW="sm" minW='xs' overflow="hidden">
                <Card.Body gap="4">
                    <Flex direction='column' gap='1'>
                        <Card.Title color='black'>{details.role} @{details.company}</Card.Title>
                        <Flex>
                            <Tag.Root backgroundColor='green.200' borderRadius='8px' color='green' fontWeight='bold' variant="solid" padding='5px 9px 5px 9px'>
                                <Tag.Label fontSize='sm' fontWeight='bold'>+ ${details.total_increase} total increase</Tag.Label>
                            </Tag.Root>
                        </Flex>
                    </Flex>
                    <Card.Description>
                        <Flex direction='column' gap='2'>
                            <Flex direction='column' gap='1'>
                                <Flex direction='column' gap='0'>
                                    <Text color='gray' fontSize='2xs'>
                                        BASE SALARY
                                    </Text>
                                    <Heading color='black' fontWeight='bold' size='xs'>
                                        ${details.initial.base} &rarr; ${details.final.base}
                                    </Heading>
                                </Flex>
                                <ProgressBar changed={details.initial.base != details.final.base}/>
                            </Flex>
                            <Flex direction='column' gap='2'>
                                <Flex direction='column' gap='0'>
                                    <Text color='gray' fontSize='2xs'>
                                        RSU GRANT / 4 YEARS
                                    </Text>
                                    <Heading color='black' fontWeight='bold' size='xs'>
                                        ${details.initial.rsus} &rarr; ${details.final.rsus}
                                    </Heading>
                                </Flex>
                                <ProgressBar changed={details.initial.rsus != details.final.rsus}/>
                            </Flex>
                            <Flex direction='column' gap='2'>
                                <Flex direction='column' gap='0'>
                                    <Text color='gray' fontSize='2xs'>
                                        ANNUAL BONUS
                                    </Text>
                                    <Heading color='black' fontWeight='bold' size='xs'>
                                        ${details.initial.annual_bonus} &rarr; ${details.final.annual_bonus}
                                    </Heading>
                                </Flex>
                                <ProgressBar changed={details.initial.annual_bonus != details.final.annual_bonus}/>
                            </Flex>
                            <Flex direction='column' gap='2'>
                                <Flex direction='column' gap='0'>
                                    <Text color='gray' fontSize='2xs'>
                                        SIGN ON BONUS
                                    </Text>
                                    <Heading color='black' fontWeight='bold' size='xs'>
                                        ${details.initial.sign_on_bonus} &rarr; ${details.final.sign_on_bonus}
                                    </Heading>
                                </Flex>
                                <ProgressBar changed={details.initial.sign_on_bonus != details.final.sign_on_bonus}/>
                            </Flex>
                        </Flex>
                    </Card.Description>
                </Card.Body>
            </Card.Root>
        </div>
    );
}

export default TestimonialCard;
